import {useLocation} from "react-router-dom";

export const useQuery = () => {
    console.log(new URLSearchParams(useLocation().search));
    return new URLSearchParams(useLocation().search);
};
